const PLATFORMS = ['X', 'YouTube', 'Google Trends'];

function Spark() {
  // 상승 곡선 — 랜딩의 유일한 그래픽 요소
  return (
    <svg className="spark" viewBox="0 0 320 96" aria-hidden="true">
      <polyline
        className="spark-line"
        points="4,80 56,62 96,70 148,44 192,54 248,24 316,8"
        fill="none"
      />
      <circle className="spark-dot" cx="316" cy="8" r="5" />
    </svg>
  );
}

export default function App() {
  return (
    <div className="page">
      <main className="hero">
        <Spark />
        <h1 className="wordmark">
          Abou<span className="shared-t">T</span><span className="trend">rend</span>
        </h1>
        <p className="tagline">크로스 플랫폼 트렌드 관측소</p>
        <p className="sub">The cross-platform trend observatory</p>

        <div className="status">
          <span className="pulse" />
          지금은 조용히 데이터를 쌓는 중입니다
          <span className="platforms">{PLATFORMS.join(' · ')}</span>
        </div>
      </main>

      <footer className="footer">
        <span>© {new Date().getFullYear()} aboutrend.com</span>
        <a href="https://0n1.io">a 0n1.io project</a>
      </footer>
    </div>
  );
}
